import React from 'react'
import NavBar from '../components/NavBar'
import AboutContent from '../components/AboutContent'
import Footer from '../components/Footer'

const About = () => {
  return (
    <div>
        <NavBar />
        <AboutContent />
        <Footer />
    </div>
  )
}

export default About